import React from "react";

function CTA() {
    return (
        <section className="cta section-padding">
            <div className="w-layout-blockcontainer container w-container">
                <div data-w-id="5cbd5fd8-72a7-6c30-852c-fb42f34766a0" className="content-wrapper cta">
                    <div className="cta-content">
                        <div className="section-title">
                            <p className="label">DIGITAL EXPERIENCE</p>
                            <div className="title">
                                <h3 className="heading-3">Join the Dam Cloud Monitoring Revolution with GeoLight</h3>
                                <p className="body-text-16 max-width">
                                    Whether you &#x27;re a beginner or an expert, our platform supports all users.
                                </p>
                            </div>
                        </div>
                        <div className="buttons">
                            <a id="w-node-_44d97935-8837-04de-0463-fd585f95030e-5f95030e" href="/contact"
                               className="button bg-theme-color-01 w-inline-block">
                                <p className="button-text">Get in touch</p>
                            </a>
                            <a id="w-node-a7fa2e15-3961-4ff9-f25d-ddea95182df9-95182df9" href="/company"
                               className="button stoke w-inline-block">
                                <p className="button-text primary">
                                    Download brochure<br/>
                                </p>
                            </a>
                        </div>
                    </div>
                    <div className="illustration position-relative">
                        <img
                            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e01649243f94cb294acc2d_map.svg"
                            loading="lazy" alt="" className="map"/>
                        <div className="project">
                            <div className="project-name">
                                <p className="body-text-10">Web3Go</p>
                            </div>
                            <img
                                src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e019b6178209eea0a1fae8_MARK.svg"
                                loading="lazy" alt="" className="marker"/>
                        </div>
                        <div className="project-2">
                            <div className="project-name">
                                <p className="body-text-10">ZenCoin</p>
                            </div>
                            <img
                                src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e019b6178209eea0a1fae8_MARK.svg"
                                loading="lazy" alt="" className="marker"/>
                        </div>
                        <div className="project-3">
                            <div className="project-name">
                                <p className="body-text-10">CryptoNova</p>
                            </div>
                            <img
                                src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e019b6178209eea0a1fae8_MARK.svg"
                                loading="lazy" alt="" className="marker"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CTA;